import * as type from './constant';

export const getPosition = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getPositionSuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getPositionError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addPosition = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addPositionSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updatePosition = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updatePositionSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deletePosition = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deletePositionSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationPositionError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
